<template>
  <div id="organuser">
    <van-divider>机构工作人员管理</van-divider>
    <div class="m-4">
      <van-button
        @click="downloadFile(getUserFileUrl())"
        round
        size="small"
        class="w-100"
      >机构工作人员名单-模板文件下载</van-button>
    </div>
    <el-form label-position="left" class="m-4 text-left">
      <el-form-item label-width="25%" size="mini">
        <template slot="label">导入数据</template>
        <el-upload
          :action="url"
          :headers="header"
          :on-progress="handleProcess"
          :on-success="handleSuccess"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :limit="9"
          :on-exceed="handleExceed"
          :show-file-list="false"
          multiple
        >
          <i class="fa fa-fw fa-cloud-upload mr-1 color-blue"></i>
          <span class="color-blue">上传工作人员名单</span>
        </el-upload>
      </el-form-item>
    </el-form>
    <!-- 选择表名 -->
    <van-popup v-model="sheet1" position="bottom" class="popup-l1" closeable round>
      <van-nav-bar title="预导入工作人员信息表" />
      <div class="m-4">
        <van-divider>点击表名选择</van-divider>
        <ul>
          <li
            v-for="(item, index) in sheet1content.TableList"
            :key="index"
            class="mt-1 color-blue"
            @click="getTableField(item)"
          >
            <i class="fa fa-fw fa-list"></i>
            {{ item }}
          </li>
        </ul>
      </div>
    </van-popup>
    <!-- 字段对应 -->
    <van-popup v-model="sheet2" position="bottom" class="popup-l1" closeable round>
      <van-nav-bar title="选择字段对应" left-text="数据关系" />
      <div class="m-4">
        <van-divider>字段对应</van-divider>
        <el-form>
          <el-form-item>
            <el-select v-model="params.RealName" placeholder="选择真实姓名" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item>
            <el-select v-model="params.Phone" placeholder="选择手机号码" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item>
            <van-switch v-model="params.IsUpdate" size="16px" />
            <small class="m-2">忽略重复数据</small>
          </el-form-item>
        </el-form>
        <van-button round hairline class="w-75" type="info" @click="setUserReportBtn">预导入工作人员信息</van-button>
      </div>
    </van-popup>
    <!-- 机构工作人员管理 -->
    <div class="text-left">
      <van-cell-group>
        <van-cell>
          <template slot="icon">
            <!-- <i class="fa fa-fw fa-bars fa-lg mt-2 mr-1"></i> -->
          </template>
          <template slot="title">
            <!-- {{option1[value1].text}} -->
            <el-select v-model="value1" placeholder="请选择" size="mini">
              <el-option
                v-for="item in option1"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="default">
            <small class="pl-2">({{ data.length }})</small>
            <small class="pl-2">呼叫</small>
            <small class="pl-2">启用</small>
            <small class="pl-2">删除</small>
          </template>
        </van-cell>
        <van-cell v-for="(item, index) in data" :key="index" size="large">
          <template slot="title">
            <i class="fa fa-fw fa-id-card-o mr-1"></i>
            <span class="mr-1">{{ item.RealName }}</span>
            <small class="text-bold">{{ item.OpenID == getAuth().OpenID ? "(当前登录)" : "" }}</small>
            <!-- <small>[{{item.UserName}}]</small> -->
          </template>
          <template slot="default" v-if="item.OpenID != getAuth().OpenID">
            <a :href="'tel:' + item.Phone">
              <i class="fa fa-lg fa-fw fa-phone" style="text-shadow:1px 1px 1px #999;"></i>
            </a>
            <i
              class="fa fa-lg ml-4"
              :class="
                item.UseFlg
                  ? 'fa-toggle-on color-green'
                  : 'fa-toggle-off color-yellow'
              "
              @click="updateBtn(item)"
              style="text-shadow:1px 1px 1px #afa;"
            ></i>
            <i
              class="fa fa-lg fa-trash ml-4 color-red"
              @click="deleteBtn(item)"
              style="text-shadow:1px 1px 1px #ffa;"
            ></i>
          </template>
          <template slot="label">
            座机:{{ item.Tel || "未填写" }}
            <br />
            手机:{{ item.Phone || "无" }}
            <br />
            机构:{{ item.OrganName }}
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "organuser",
  data() {
    return {
      data: [],
      value1: 3,
      option1: [
        { text: "预先导入", value: -1 },
        { text: "停用账号", value: 0 },
        { text: "启用账号", value: 1 },
        { text: "查看全部", value: 3 }
      ],
      sheet1: false,
      sheet1content: {
        FileID: "",
        TableList: [],
        TableName: ""
      },
      sheet2: false,
      sheet2content: {
        data: []
      },
      params: {
        WorkID: "000000",
        SplitProcessID: "000000",
        FileID: "",
        module: "OrganUserInfoImport",
        TableName: "",
        IsUpdate: false,
        OrganID: this.getWork()
          ? this.getAddr().OrganID
          : this.getAuth().OrganID,
        RealName: "",
        Phone: ""
      }
    };
  },
  watch: {
    // eslint-disable-next-line
    value1(newVal, oldVal) {
      this.drawData();
    }
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    //上传进度
    // eslint-disable-next-line
    handleProcess(event, file, fileList) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传" + file.percentage.toFixed(0) + "%"
      });
    },
    //点击已上传的文件链接时的钩子, 可以通过 file.response 拿到服务端返回数据
    handlePreview() {},
    //文件列表移除文件时的钩子
    handleRemove() {},
    //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeRemove() {},
    //文件超出个数限制时的钩子
    handleExceed() {},
    // eslint-disable-next-line
    handleSuccess(response, file, fileList) {
      this.$toast.clear();
      //console.log("文件上传成功返回", response, file, fileList);
      if (response.code == 20000) {
        this.$toast(response.message);
        this.sheet1 = true;
        this.params.FileID = response.data.FileID;
        this.sheet1content.FileID = response.data.FileID;
        this.sheet1content.TableList = response.data.TableList;
      } else {
        // 以弹出框的形式提示异常信息
        this.$dialog
          .alert({ title: "上传文件异常", message: response.message })
          .then(() => {
            // on close
          });
      }
    },
    getTableField(item) {
      //将参数对象表名改为当前选择表
      this.params.TableName = item;
      this.apiUserUploadFileFieldGet(
        {
          WorkID: "000000",
          SplitProcessID: "000000",
          FileID: this.sheet1content.FileID,
          TableName: item,
          module: "OrganUserInfoImport"
        },
        this,
        res => {
          this.params.RealName = "";
          this.params.Phone = "";
          this.sheet1 = false;
          this.sheet2content.data = res.data;
          this.sheet2 = true;
        }
      );
    },
    /* 导入机构用户信息 */
    setUserReportBtn() {
      this.apiUserReportPost(this.params, this, res => {
        this.$toast(res.message);
        if (res.code == 20000) {
          this.sheet2 = false;
          this.drawData();
        }
        if (res.code == 20021) {
          let msg = "检查到重复数据:\n";
          res.data.data.forEach(element => {
            msg += "手机号:" + element.Phone + "(重复);\n";
          });
          this.$dialog
            .alert({
              title: "提示",
              message: msg
            })
            .then(() => {
              // on close
            });
        }
      });
    },
    /* 绘制数据 */
    drawData() {
      this.apiReviewRegOrganUserGet(
        {
          WorkID: "000000",
          SplitProcessID: "000000",
          OrganID: this.getWork()
            ? this.getAddr().OrganID
            : this.getAuth().OrganID,
          UseFlg: this.value1,
          UserType: this.getAuth().UserType
        },
        this,
        res => {
          this.data = res.data.list_data;
        }
      );
    },
    updateBtn(item) {
      let _tip = "提示语";
      let _flg = true;
      if (item.UseFlg) {
        _tip = "停用账号?";
        _flg = false;
      } else {
        _tip = "启用账号?";
        _flg = true;
      }
      this.$dialog
        .confirm({ title: "提示", message: _tip })
        .then(() => {
          // on confirm
          this.apiReviewRegOrganUserPut(
            {
              WorkID: "000000",
              SplitProcessID: "000000",
              OpenID: item.OpenID,
              UseFlg: _flg
            },
            this, // eslint-disable-next-line
            res => {
              this.drawData();
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteBtn(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "操作执行后无法还原, 确定删除账号?"
        })
        .then(() => {
          // on confirm
          this.apiReviewRegOrganUserDelete(
            {
              WorkID: "000000",
              SplitProcessID: "000000",
              OpenID: item.OpenID
            },
            this, // eslint-disable-next-line
            res => {
              this.drawData();
            }
          );
        })
        .catch(() => {
          // on confirm
        });
    }
  },
  created() {
    this.drawData();
    this.url = this.apiUserUploadFileUrl(); //机构工作人员上传组件地址
    this.header = this.getUserUploadFileParam(); //机构工作人员上传头参数
  }
};
</script>

<style scoped>
</style>